import { componentSpacing01 } from '../../../../../tokens';
export var headerNavigationMenuContentHeaderTheme = {
  Title: {
    base: {
      marginBottom: componentSpacing01,
      color: '$color.neutral.05'
    }
  },
  Label: {
    base: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0
    }
  }
};